import * as React from 'react';
import * as Chakra from '@chakra-ui/react';

function IndexPage(): JSX.Element {
  return (
    <Chakra.Box p={4}>
      <Chakra.Heading mb={4}>In progress... sorry!</Chakra.Heading>
    </Chakra.Box>
  );
}

export default IndexPage as React.FC;
